import { IconBuildingSkyscraper, IconPlaneDeparture } from "@tabler/icons-react";

// Round illustrated airplane + hotel icon for the "Avio ceļojumi" (flight + hotel) section
// header — uses the same professionally-drawn Tabler icon glyphs as the rest of the app
// (composited on a soft gradient badge) instead of hand-drawn SVG paths, which read as rough/
// cheap at this size compared to VacationIcon/BusIcon's flatter illustration style.
export function FlightHotelIcon({ size = 72 }) {
  return (
    <div
      style={{
        position: "relative",
        width: size,
        height: size,
        borderRadius: "50%",
        background: "linear-gradient(160deg, #dceeff 0%, #e6dcf8 100%)",
        overflow: "hidden",
      }}>
      <IconPlaneDeparture
        size={Math.round(size * 0.48)}
        stroke={1.6}
        color="#0878f9"
        style={{
          position: "absolute",
          left: "18%",
          top: "14%",
        }}
      />
      <IconBuildingSkyscraper
        size={Math.round(size * 0.36)}
        stroke={1.6}
        color="#7c5cd6"
        style={{
          position: "absolute",
          right: "12%",
          bottom: "10%",
        }}
      />
    </div>
  );
}
